<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DTagsEditor',
  extends: compoment
}
</script>
